<template>
  <div>
    <div class="system_header">
      <img class="logo_img" :src="logoSrc">
      <div class="header_name">
        <!-- ../assets/img/logo.png -->
        <!-- 在线教育管理后台 -->
        {{ gardenName}}
      </div>
      <div class="language_box region_box">
        <span class="message-notice" @click.stop="changeMessageCenter">
          <!-- <i class="iconfont icon-xiaoxizhongxin"></i>         -->
          <img v-if="isNewMessage" style="width: 16px;marginTop:2px" src="../assets/img/newMessage.png" alt="">
          <img v-else style="width: 16px;marginTop:2px" src="../assets/img/message.png" alt="">
        </span>
        <el-dropdown trigger="click" @command="menuClick">
          <span class="el-dropdown-link">
            {{user_emp_no}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item>总部园长</el-dropdown-item>
            <el-dropdown-item>分区园长</el-dropdown-item> -->
            <el-dropdown-item command="baseInfo">基本信息</el-dropdown-item>
            <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <span class="vertical_line">|</span>
      <div class="language_box chiese_english">
        <el-radio-group v-model="language_state" @change="chageLanguage(language_state)" size="mini">
          <el-radio-button label="Chinese">中文</el-radio-button>
          <span class="language_seperator">/</span>
          <el-radio-button label="English">EN</el-radio-button>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/components/TreeTable/bus";
export default {
  name: "App",
  data() {
    return {
      language_state: "Chinese",
      gargenManageValue: "1",
      logoSrc:'',
      gardenName:'',
      user_emp_no: '',
    };
  },
  computed: {
    isNewMessage: {
      get: function() {
        let newMessage = false;
        if (this.$store.state.messageCenter.newNoticeMessage || this.$store.state.messageCenter.newSystemMessage) {
          newMessage = true;
        } 
        return newMessage;
      },
      set: function(value) {}
    }
  },
  created() {
    window.addEventListener('setItem', ()=> {
      this.user_emp_no = sessionStorage.getItem('user_empNo');
    })
  },
  mounted() {
      const self=this;
      self.getLogo();
      Bus.$on("editSuccess",target=>{
          self.getLogo();
      })
  },
  methods: {
    chageLanguage: function(language_state) {
      let locale = this.$i18n.locale;
      console.log(locale);
      locale === "cn" ? (this.$i18n.locale = "en") : (this.$i18n.locale = "cn");
    },
    menuClick(command) {
      const self = this;
      console.log(`点击：${command}`);
      if (command == "loginOut") {
        self.loginOut();
      } else if(command == "changePwd"){
        self.$router.push("/moduleIndex/systemSet/passwordChange");
      } else if(command == "baseInfo"){
        self.$router.push("/moduleIndex/systemSet/information");
      } 
    },
    loginOut() {
      window.sessionStorage.removeItem("token");
      this.$store.dispatch('clear_tags');
      this.$router.push("/login");
      sessionStorage.clear()
    },
    getLogo(){
      this.$get('config/getSystemConfig').then((res)=>{
         if(res.code==='00'){
           this.user_emp_no = sessionStorage.getItem('user_empNo');
           this.logoSrc=res.data.value1 || '../assets/img/logo.png'
           this.gardenName=res.data.value2 || 'KRK幼儿园管理平台'
         }
      })
    },
    changeMessageCenter() {
      this.$store.commit("CHANGE_MESSAGE_CENTER_SHOW", !this.$store.state.messageCenter.HeaderMessageCenterShow);
    }
  }
};
</script>

<style lang="scss">
@import "../assets/css/variables.scss";
.el-dropdown {
  top: 2px;
  margin-left: 21px;
  margin-right: 16px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  font-size: 14px;
}
.chiese_english {
  position: relative;
  top: 2px;
  margin-right: 30px;
}
.system_header {
  width: 100%;
  height: 60px;
  background: #fff;
  color: #fff;
  text-align: right;
}
.logo_img {
  height: 100%;
  width: 220px;
  float: left;
  /* margin-left: 100px; */
}
.language_box {
  display: inline-block;
  margin-top: 12px;
  width: 74px;
  .el-radio-button--mini .el-radio-button__inner {
    border: none;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: transparent;
    color: $color-primary;
  }
  .el-radio-button--mini .el-radio-button__inner {
    padding: 7px 6px;
  }
  .el-radio-button__inner {
    color: #a2a4a9;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .el-radio-button:first-child .el-radio-button__inner{
    border:none;
  }
  .message-notice {
    cursor: pointer;
    width: 40px;
    height: 40px;
    display: inline-block;
    text-align: center;
    line-height: 40px;
  }
}
.vertical_line {
  color: $color-primary;
}
.header_name {
  float: left;
  height: 60px;
  line-height: 60px;
  font-size: 22px;
  /* margin-left: 64px; */
  color: #333;
}
.region_box {
  width: auto;
  .el-icon-arrow-up:before {
    color: $color-primary;
  }
  .el-input__inner {
    border: none;
    color: $color-primary;
  }
}
.language_seperator {
  position: relative;
  top: 7px;
  font-size: 17px;
  color: #a2a4a9;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
/* ::-webkit-scrollbar   
  {   
      width: 16px;   
      height: 16px;   
      background-color: #F5F5F5;   
  }    */

/*定义滚动条轨道 内阴影+圆角*/
/* ::-webkit-scrollbar-track   
  {   
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);   
      border-radius: 10px;   
      background-color: #F5F5F5;   
  }    */

/*定义滑块 内阴影+圆角*/
/* ::-webkit-scrollbar-thumb   
  {   
      border-radius: 10px;   
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);   
      background-color: #555;   
  }   */
</style>


// WEBPACK FOOTER //
// src/components/headerSystem.vue